import React from "react"
import { connect } from "react-redux"
import { removeFromCart } from "../../actions/shoppingCart"
// HOC to Add remove functionaility to a Component

const RemoveFromCart = Component => {
  const HOC = props => {

    const removeFromCartAction = id => {
      props.dispatch(removeFromCart(id))
    }
    return (
      <span
        className={props.customClassName}
        onClick={() => {
          removeFromCartAction(props.id)
        }}
      >
        <Component />
      </span>
    )
  }

  return connect()(HOC)
}

export default RemoveFromCart
